import PropTypes from 'prop-types';

const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

export { refType$1 as default };
//# sourceMappingURL=refType.js.map
